"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VbzLoadingLogo = void 0;
const react_1 = __importDefault(require("react"));
const className_1 = require("../../utils/className");
exports.VbzLoadingLogo = ({ id = '' }) => {
    return (react_1.default.createElement("div", { id: id, className: "vbz-loading-logo" },
        react_1.default.createElement("div", { className: className_1.mapToCssModules(['vbz-logos', 'smiles-symbol']) })));
};
//# sourceMappingURL=index.js.map